import { ReactElement, SVGProps } from 'react';
import BaseIcon from './BaseIcon';

export default function ElectricIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props} viewBox="0 0 31 31">
      <path
        d="M11.75 19.25H7.875q-.75 0-1.11-.672-.359-.672.079-1.297l9.343-13.437q.313-.438.813-.61t1.031.016.782.656q.25.47.187 1L18 13h4.844q.812 0 1.14.719.329.718-.203 1.344L13.5 27.374q-.344.406-.844.531a1.42 1.42 0 0 1-.969-.093 1.64 1.64 0 0 1-.734-.672 1.54 1.54 0 0 1-.203-.985z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
